import DataGenerator from './Main'

export default DataGenerator



// WEBPACK FOOTER //
// ./src/views/DataGenerator/index.js